import {createAsyncThunk} from "@reduxjs/toolkit";
import {handlerError} from "../../../store/handleError";
import {fuelCalibrationAPI} from "../api";
import {setMessage} from "../../messages/model/slice";
import {MESSAGE_SEVERITY} from "../../../utils/const";
import {thunkHandlers} from "../../../store/thunkHandlers";
import {AppDispatch} from "../../../store";
import {IFuelCalibration, IFuelTank} from "../../../models/IFuelCalibration";

const messages = {
    save: {error: "Не удалось сохранить тарировку.", success: "Тарировка сохранена"},
    delete: {error: "Не удалось удалить тарировку.", success: "Тарировка удалена"},
};

type ThunkConfig = {
    dispatch: AppDispatch;
    rejectValue: string;
};

export const fetchGetFuelCalibration = createAsyncThunk<IFuelTank[], string, ThunkConfig>(
    "fuelCalibration/get",
    async (machineryId, {rejectWithValue}) => {
        try {
            return await fuelCalibrationAPI.getByMachinery(machineryId);
        } catch (e) {
            return rejectWithValue(handlerError(e));
        }
    },
);

export const fetchSaveFuelCalibration = createAsyncThunk<IFuelTank[], {
    machineryId: string;
    data: IFuelCalibration
}, ThunkConfig>(
    "fuelCalibration/save",
    async ({machineryId, data}, {rejectWithValue, dispatch}) => {
        try {
            const res = await fuelCalibrationAPI.save(machineryId, data);
            thunkHandlers.success(messages.save.success, dispatch);
            return res;
        } catch (e) {
            const errorMessage = e instanceof Error ? e.message : "Неизвестная ошибка";
            dispatch(
                setMessage({
                    severity: MESSAGE_SEVERITY.error,
                    text: errorMessage || messages.save.error,
                }),
            );
            return rejectWithValue(handlerError(e));
        }
    },
);

export const fetchDeleteFuelCalibration = createAsyncThunk<string, string, ThunkConfig>(
    "fuelCalibration/delete",
    async (machineryId, {rejectWithValue, dispatch}) => {
        try {
            await fuelCalibrationAPI.remove(machineryId);
            thunkHandlers.success(messages.delete.success, dispatch);
            return machineryId;
        } catch (e) {
            const errorMessage = e instanceof Error ? e.message : "Неизвестная ошибка";
            dispatch(
                setMessage({
                    severity: MESSAGE_SEVERITY.error,
                    text: errorMessage || messages.delete.error,
                }),
            );
            return rejectWithValue(handlerError(e));
        }
    },
);